<template>
  <div>
    <div class="container-fluid right_wrapper">
      <ProductListFilter></ProductListFilter>
      <div
        v-if="showLoader"
        class="spinner-border"
        style="margin: auto; display: block; margin-top: 60px"
      ></div>
      <div v-else>
        <ProductListGrid class="table_wrap"></ProductListGrid>
        <div
          class="dropup"
          v-if="selectedProducts && selectedProducts.length > 0"
        >
          <div
            class="bulk_action dropdown-toggle"
            id="dropdownMenuButton"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <span class="text">Bulk Actions</span>
            <!-- <div style="padding-left:10px;float:left"><i class="fas fa-caret-up"></i></div> -->
          </div>
          <ProductListAction />
        </div>

        <ProductListGridFooter
          v-if="productList && productList.length > 0"
          class="main_footer_wrap"
        ></ProductListGridFooter>
      </div>
    </div>
    <!-- Modal Starts -->
    <ProductListAddVendorModal></ProductListAddVendorModal>
    <ProductListAddToCampaignModal></ProductListAddToCampaignModal>
  </div>
</template>

<script>
import MainHeader from "@/components/MainHeader";
import ProductListFilter from "@/components/product/ProductListFilter";
import ProductListAction from "@/components/product/ProductListAction";
import ProductListGrid from "@/components/product/ProductListGrid";
import MainFooter from "@/components/MainFooter";
import ProductListAddVendorModal from "@/components/product/ProductListAddVendorModal";
import ProductListAddToCampaignModal from "@/components/product/ProductListAddToCampaignModal";

import ProductListGridFooter from "@/components/product/ProductListGridFooter";
export default {
  components: {
    MainHeader,
    ProductListFilter,
    ProductListAction,
    ProductListGrid,
    MainFooter,
    ProductListAddVendorModal,
    ProductListAddToCampaignModal,
    ProductListGridFooter,
  },
  mounted() {
    this.$store.dispatch("callAnalytics", {
      data: window.location.href,
      this: this,
      type: "productList",
    });
    this.sort = {
      field: "product_title",
      order: "asc",
    };
    if (this.$store.state.calledFromCancel) {
      this.$store.state.calledFromCancel = false;
    }
    else{
	    this.$store.dispatch("getAllVendorForProduct")
      this.$store.commit("clearProductList")
    }
  },
  computed: {
    productList: {
      set(val) {
        this.$store.state.product.productList = val;
      },
      get() {
        return this.$store.state.product.productList;
      },
    },
    selectedProducts: {
      set(val) {
        this.showCannotDel = false;
        this.cannotDelArray = [];
        this.$store.state.product.selectedProducts = val;
      },
      get() {
        return this.$store.state.product.selectedProducts;
      },
    },
    showLoader: {
      get() {
        return this.$store.getters["getShowLoader"];
      },
    },
    sort: {
      set(val) {
        this.$store.commit("setSelectedSortOrder", val);
      },
      get() {
        return this.$store.state.selectedSortOrder;
      },
    },
  },
  beforeDestroy() {
    this.sort = {
      field: "name",
      order: "asc",
    };
  },
  methods: {
    executeJQueryScript() {
      $("#addEditCampaignGroup").modal({
        backdrop: "static",
        show: false,
      });

      $(function () {
        $("td:first-child input").change(function () {
          $(this).closest("tr").toggleClass("highlight", this.checked);
        });
      });

      $(document).ready(function () {
        $(".strategy").click(function () {
          //alert();
          $(".strategy").removeClass("sales roi");
          let ref = $(this).addClass("sales");
          if (ref.attr("id") == "roi") {
            ref.addClass("roi");
          }
        });

        $(".go-popover")
          .popover({
            html: true,
            content: function () {
              return $("#toCampaign").html();
            },
          })
          .on("shown.bs.popover", function () {
            $(".tagsListing").click(function () {
              $("#campaign-tags-new, #campaign-tags").toggle(200);
            });
          });
      });
    },
  },
};
</script>
<style lang="scss">
.right_wrapper {
  padding-left: 0px !important;
  padding-right: 0px !important;
  margin-left: 0px !important;
  margin-right: 0px !important;
  .inp_header {
    box-sizing: border-box;
    height: 43px;
    width: 220px;
    border: 1px solid #979797;
    border-radius: 6px;
    background-color: #fff;
  }
  .main_footer_wrap {
    border: none;
    height: 80px;
    width: 100%;
    overflow: hidden;
    padding: 10px;
  }
  .bulk_action {
    position: fixed;
    bottom: 105px;
    right: 30px;
    height: 43px;
    width: 146px;
    border-radius: 21.5px;
    background-color: #ffbf3f;
    padding: 11px 8px 8px 14px;
    cursor: pointer;
    .text {
      height: 19px;
      color: #333333;
      font-family: "Nunito Sans";
      font-size: 14px;
      font-weight: bold;
      float: left;
      padding-right: 7px;
    }
  }
  .table_wrap {
    // margin-top: 15px;
    height: calc(100vh - 155px);
    width: 100%;
    overflow: auto;
    &.no_footer{
      height: calc(100vh - 75px) !important;
    }
    &.extra_bar{
      height: calc(100vh - 215px) !important;
    }
    &.extra_component{
      height: calc(100vh - 305px) !important
    }

    .table thead {
      background-color: white;
      top: 0;
      z-index: 1;
    }
    .table thead th {
      border: 0px !important;
      color: #333333;
      font-family: Roboto;
      font-size: 16px;
      font-weight: 900;
      letter-spacing: -0.07px;
      line-height: 19px;
    }
    .table tbody td {
      border: 0px !important;
      color: #333333;
      font-family: Roboto;
      font-size: 16px;
      letter-spacing: -0.07px;
      line-height: 23px;
      word-wrap: break-word;
    }
    .table tbody tr.even {
      background-color: #fafafa;
    }
    .table tbody tr:hover {
      background-color: white;
    }
    .table tbody tr.even:hover {
      background-color: #fafafa;
    }
    .table tbody td{
      vertical-align: top !important;
      .row-add-edit{
        padding-top:3px;
        max-width:10px;
        .item-add-edit{
          display: block !important;
          opacity: 0.5 ;
        }
        .item-add-edit:hover{
          opacity: 1 !important;
        }
      }
      .label-info{
        background-color: #5bc0de;
      }
      .label {
        display: inline;
        padding: 0.2em 0.6em 0.3em;
        font-size: 75%;
        font-weight: 700;
        line-height: 1;
        color: #fff;
        text-align: center;
        white-space: nowrap;
        vertical-align: baseline;
        border-radius: 0.25em;
      }
    }
    .bulk_action {
      height: 43px;
      width: 146px;
      border-radius: 21.5px;
      background-color: #ffbf3f;
    }
  }
}
</style>
